module.exports = __webpack_public_path__ + "img/class-no.6f943e94.png";